// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__n2b21","open":"styles_open__POFle","vertical":"styles_vertical__F05AF","horizontal":"styles_horizontal__iyDAK"};